export default function getCleanCategorys(data = []) {
  const categorys = []
  data.map((item) => {
    categorys.push({ name: item.nome, url: item.slug, icon: item?.icon })
  })
  //Movendo a categoria de diversos para ser exibida por último
  const diversos = categorys.find((el) => el.name === 'Diversos')
  if (diversos) {
    categorys.splice(categorys.indexOf(diversos), 1)
    categorys.push(diversos)
  }

  return categorys || []
}
